import React, { useEffect, useState } from "react";

const BannerRenderer = ({ image, link, linkEnabled }) => {
  const [isMobile, setIsMobile] = useState(false);

  // Helper function to ensure link has https:// or http://
  const formatLink = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return `https://${url}`;
    }
    return url;
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const imageElement = (
    <img
      src={image}
      alt="Banner"
      style={{
        width: isMobile ? "100vw" : "468px",
        height: "60px",
        position: "fixed",
        bottom: 0,
        left: isMobile ? 0 : "50%",
        transform: isMobile ? "none" : "translateX(-50%)",
        boxSizing: "border-box",
        cursor: linkEnabled ? "pointer" : "default",
      }}
    />
  );

  if (!linkEnabled) {
    return imageElement;
  }

  return (
    <a href={formatLink(link)} target="_blank" rel="noopener noreferrer">
      {imageElement}
    </a>
  );
};

export default BannerRenderer;
